import { EngagementPlanResponseSchema } from "@l30/shared";
import { useQuery } from "@tanstack/react-query";

import { portalFetch } from "./portal-client.js";

/**
 * Portal-side plan-view hook.
 *
 * Single-shot read of the partner's default engagement + its non-
 * archived stakeholders + milestones. Read-only — the staff app
 * owns edits.
 */
const PLAN_KEY = ["portal", "plan"] as const;

export function usePortalPlan(enabled = true) {
  return useQuery({
    queryKey: PLAN_KEY,
    queryFn: () => portalFetch("/portal/plan", {}, EngagementPlanResponseSchema),
    // Plan content changes infrequently from the portal user's
    // perspective; aggressive cache is fine. Re-fetch on window focus
    // so updates from staff land without a hard reload.
    staleTime: 60 * 1000,
    enabled,
  });
}
